import { queryOptions } from '@tanstack/react-query';
import user from '../helpers/user';
import h, { getCountry } from '../helpers/common';
import { STORE_NAME } from '@intigral/constant';
import { KIDSMODE } from '@libs/constants';
import { container } from '@intigral/domain/lib/DataDomain';
import { IThinkAnalyticsService } from '@intigral/domain/lib/application/services/ThinkAnalyticsService';
import { DI } from '@intigral/constant/config/DIContainer';
import { transformResponseList } from '../utils/transformResponse/thinkAnalyticsResponse';
import { moodsQueryKeys } from './useMoodsQuery';
export interface FeelingLuckyData {
    data: any[];
    isVOD: boolean;
    genre: string;
    category: string;
}

// Query options for feeling lucky
export const feelingLuckyQueryOptions = () =>
    queryOptions<FeelingLuckyData, Error>({
        queryKey: moodsQueryKeys.lucky(),
        queryFn: async (): Promise<FeelingLuckyData> => {
            try {
                const { apiKey, identityToken, username, subscriptionGUID } = h.getStore(STORE_NAME.USER) || {};
                const profileName = user.getProfileName();
                const userProfile = user.getProfile();
                const rating = userProfile.newParentalControl || userProfile.parentalControl;
                const country = getCountry();
                const device = h.getDevice();
                const guids = subscriptionGUID.join('|');
                const isKidsProfile = user.getProfileMode() === KIDSMODE.KID;

                const taService = container.resolve<IThinkAnalyticsService>(DI.SERVICES.IThinkAnalyticsService);
                const response = await taService.getFeelingLucky(
                    apiKey,
                    identityToken,
                    profileName,
                    username,
                    device,
                    country,
                    guids,
                    rating,
                    isKidsProfile
                );

                const dataType = response.data.vod ? 'vod' : response.data.channels ? 'channels' : null;
                if (dataType && Array.isArray(response.data[dataType]) && response.data[dataType].length > 0) {
                    const isVOD = dataType === 'vod';
                    const data = isVOD
                        ? transformResponseList({ entries: response.data[dataType] })
                        : response.data[dataType];

                    return {
                        data,
                        isVOD,
                        genre: response.data.genre || '',
                        category: response.data.assetCategory || '',
                    };
                } else {
                    return { data: [], isVOD: false, genre: '', category: '' };
                }
            } catch (err) {
                throw new Error(err?.message || 'An error occurred while fetching data.');
            }
        },
        staleTime: 2 * 60 * 1000, // 2 minutes (lucky content should be more fresh)
        gcTime: 5 * 60 * 1000, // 5 minutes
        retry: 2,
        refetchOnWindowFocus: false,
    });
